<template>
  <div class="slider__card">
    <img src="~@/assets/images/slider-item-imgs/ico226.svg" alt="ico226.svg">
    <div class="text-container">
      <text-string label-id="txt1437"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "storage-instruction-four",
  }
</script>
